module.exports = __webpack_public_path__ + "img/it.aff0a325.svg";